import "core-js/modules/es.number.constructor";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-chart-pie",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {
      uuid: '',
      chartOption: {},
      chart: undefined,
      cptData: []
    };
  },
  watch: {
    'option.attribute': {
      handler: function handler(newObj) {
        this.loadChart(newObj);
      },
      deep: true //深度监听

    },
    width: function width() {
      this.chart.resize();
    },
    height: function height() {
      this.chart.resize();
    }
  },
  created: function created() {
    this.uuid = require('uuid').v1();
  },
  mounted: function mounted() {
    this.chart = this.$echarts.init(document.getElementById(this.uuid));
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ChartPie").then(function (res) {
        _this.cptData = res;

        _this.loadChart(_this.option.attribute);
      });
    },
    loadChart: function loadChart(attribute) {
      var that = this;
      that.chartOption = {
        color: attribute.pieColor,
        title: {
          text: attribute.chartTitle,
          subtext: attribute.subtext,
          left: attribute.titleX,
          top: attribute.titleY,
          textStyle: {
            fontSize: attribute.titleFontSize,
            color: attribute.titleTextColor
          },
          // 副标题文本样式设置
          subtextStyle: {
            fontSize: 12,
            color: attribute.subtextColor
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: attribute.legendShow,
          orient: attribute.orient,
          x: attribute.legendX,
          y: attribute.legendY,
          textStyle: {
            color: attribute.legendTextColor,
            fontSize: attribute.legendFontSize
          }
        },
        series: [{
          name: attribute.chartTitle,
          type: 'pie',
          roseType: attribute.roseType === 'false' ? false : attribute.roseType,
          radius: [attribute.radiusInside + '%', attribute.radiusOutside + '%'],
          label: {
            position: attribute.labelPosition,
            fontSize: attribute.labelFontSize,
            color: attribute.labelColor
          },
          itemStyle: {
            borderRadius: attribute.borderRadius
          },
          data: this.cptData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(255, 0, 0, 0.5)'
            }
          }
        }]
      };
      that.chart.setOption(that.chartOption);
    }
  }
};